module.exports = __webpack_public_path__ + "static/media/008.10263934.jpg";